import script from "./MedicationActionPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./MedicationActionPopup.vue?vue&type=script&setup=true&lang=ts"

import "./MedicationActionPopup.vue?vue&type=style&index=0&id=6577148a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6577148a"]])

export default __exports__